<template>
  <div>
    <Topbar title="Mon captain" />
    <div style="background: #fff;">
      <section class="Section">
        <div class="Brand">
          <img
            src="../assets/images/monkey.png"
            alt="Un singe avec un chapeau de marin tenant une bouteille de vin avec une référence à Walt Whitman…"
          />
        </div>
        <h2 class="Agent__name">
          {{ agent.firstname }} {{ agent.lastname }}
        </h2>
        <div class="Agent__company">Captain Vin</div>
        <div class="Agent__desc">
          <template v-if="agent.description">
            {{ agent.description }}
          </template>
          <ul v-else>
            <li>Ce sont  des prix étudiés pour les professionnels</li>
            <li>Ce sont des offres ou des nouveautés au fil des opportunités que proposent les domaines</li>
            <li>C’est un choix particulièrement large entre vins à série limitée et vins de consommation plus régulière</li>
            <li>C’est un conseiller à votre disposition permanente pour poser absolument toutes les questions qui vous viennent à l’esprit.</li>
          </ul>
        </div>
        <div class="button-row">
          <a class="Button Button--outline" :href="`mailto:${agent.email}`">
            <IconBase class="Button__Icon" iconName="email"><IconEmail /></IconBase>
            &nbsp;Email
          </a>
          <a class="Button Button--outline" :href="`tel:${phone}`">
            <IconBase class="Button__Icon" iconName="phone"><IconPhone /></IconBase>
            &nbsp;{{ phone }}
          </a>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import IconPhone from "../components/icons/IconPhone";
import IconEmail from "../components/icons/IconEmail";

export default {
  computed: {
    phone() {
      return this.agent.cellular || this.agent.phone;
    },
    ...mapGetters("auth", ["agent"])
  },
  components: {
    IconPhone,
    IconEmail
  }
};
</script>

<style lang="scss" scoped>
@import '../assets/variables';

.Agent {
  &__name {
    font-size: 1.125rem;
  }

  &__company {
    font-size: 0.75rem;
  }

  &__desc {
    font-size: 0.875rem;
    line-height: 1.3;
    margin-bottom: $global-margin * 2;

    ul {
      margin-left: $global-margin;

      li {
        list-style-type: disc;
        margin-bottom: $global-margin / 4;
      }
    }
  }
}

.button-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: $global-margin/2;
  margin-bottom: $global-margin;
}

@media (min-width: 900px) {
  .Agent__illustration {
    float: left;
    width: 50%;
  }

  .button-row {
    margin-left: auto;
  }
}
</style>
